// extracted by mini-css-extract-plugin
export default {"sectionSelect":"styles_sectionSelect__gcnR8"};